import { TohumUiModule } from '@anadolu-commons/tohum-ui';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aof-header-logo',
  standalone: true,
  imports: [TohumUiModule],
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss']
})
export class HeaderLogoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
